<template>
    <div
        id="main-view"
        class="main-view"
    >
        <nav-bar-container :isEnableAppMenu="true"></nav-bar-container>
        <div class="content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import NavBarContainer from '@/components/common/nav-bar-container.vue';

export default {
    name: 'main-view',

    components: {
        NavBarContainer,
    },
};
</script>

<style lang="css" scoped>
.main-view {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

.main-view .content {
    flex: 1;
}
</style>
